import { PATH } from "@/configs/router/routerConfig";

const SIGNUP_SETUP_PATH = PATH?.SIGNUP_SETUP || "/signup/setup";

export const isSignupSetupRoute = (value?: string | string[] | null): boolean => {
  const raw = Array.isArray(value) ? value[0] : value;
  if (typeof raw !== "string") {
    return false;
  }

  const trimmed = raw.trim();
  if (!trimmed) {
    return false;
  }

  return trimmed.split("?")[0].split("#")[0] === SIGNUP_SETUP_PATH;
};

export const normalizeSignupBackTo = (value?: string | string[] | null): string | null => {
  const raw = Array.isArray(value) ? value[0] : value;
  if (typeof raw !== "string") {
    return null;
  }

  const trimmed = raw.trim();
  if (!trimmed || !trimmed.startsWith("/") || trimmed.startsWith("//")) {
    return null;
  }

  if (isSignupSetupRoute(trimmed)) {
    return null;
  }

  return trimmed;
};

const normalizeInvitationCode = (value?: string | string[] | null): string => {
  const raw = Array.isArray(value) ? value[0] : value;
  return typeof raw === "string" ? raw.trim() : "";
};

export const buildSignupSetupPath = (
  backTo?: string | string[] | null,
  invitationCode?: string | string[] | null
): string => {
  const searchParams = new URLSearchParams();
  const normalizedBackTo = normalizeSignupBackTo(backTo);
  if (normalizedBackTo) {
    searchParams.set("backTo", normalizedBackTo);
  }

  const normalizedInvitationCode = normalizeInvitationCode(invitationCode);
  if (normalizedInvitationCode) {
    searchParams.set("invitationcode", normalizedInvitationCode);
  }

  const query = searchParams.toString();
  return query ? `${SIGNUP_SETUP_PATH}?${query}` : SIGNUP_SETUP_PATH;
};

export const buildSignupVerificationPath = (
  backTo?: string | string[] | null,
  invitationCode?: string | string[] | null
): { pathname: string; query?: { backTo?: string; invitationcode?: string } } | string => {
  const searchParams = new URLSearchParams();
  const normalizedBackTo = normalizeSignupBackTo(backTo);
  if (normalizedBackTo) {
    searchParams.set("backTo", normalizedBackTo);
  }

  const normalizedInvitationCode = normalizeInvitationCode(invitationCode);
  if (normalizedInvitationCode) {
    searchParams.set("invitationcode", normalizedInvitationCode);
  }

  const query = searchParams.toString();
  return query
    ? {
        pathname: PATH.VERIFY_EMAIL,
        query: Object.fromEntries(searchParams.entries()) as { backTo?: string; invitationcode?: string }
      }
    : PATH.VERIFY_EMAIL;
};

export const buildPostSignupContinuationPath = (
  backTo?: string | string[] | null,
  invitationCode?: string | string[] | null
): string => {
  const normalizedBackTo = normalizeSignupBackTo(backTo);
  const normalizedInvitationCode = normalizeInvitationCode(invitationCode);

  if (normalizedInvitationCode) {
    return buildSignupSetupPath(normalizedBackTo, normalizedInvitationCode);
  }

  return buildSignupSetupPath(normalizedBackTo);
};
